import React from 'react';

const Heading = () =>{
    return(
        <div className="u-center-text">
            <h1 className="f1"> Welcome to Hogwarts</h1><br/>
            <h1 className="f2">The best school of Witchcraft and Wizardry</h1>
        </div>
    );
}

export default Heading